import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "modal-body call-panel-body",
  style: {"flex":"1","overflow":"hidden","display":"flex","flex-direction":"column"}
}
const _hoisted_2 = { class: "sms-layout" }
const _hoisted_3 = {
  key: 0,
  class: "sms-loading-state"
}
const _hoisted_4 = {
  key: 1,
  class: "sms-empty-state sms-empty-state--no-phone"
}
const _hoisted_5 = { class: "sms-empty-state__content" }
const _hoisted_6 = {
  key: 2,
  class: "sms-empty-state sms-empty-state--no-phone"
}
const _hoisted_7 = { class: "sms-empty-state__content" }
const _hoisted_8 = {
  key: 3,
  class: "sms-content-wrapper"
}
const _hoisted_9 = {
  key: 0,
  class: "sms-list-view"
}
const _hoisted_10 = { class: "sms-sidebar-header" }
const _hoisted_11 = {
  key: 0,
  class: "sms-conversations-loading"
}
const _hoisted_12 = {
  key: 1,
  class: "sms-empty-state sms-empty-state--no-conversations"
}
const _hoisted_13 = { class: "sms-empty-state__content" }
const _hoisted_14 = {
  key: 2,
  class: "sms-empty-state sms-empty-state--no-conversations"
}
const _hoisted_15 = { class: "sms-empty-state__content" }
const _hoisted_16 = {
  key: 1,
  class: "sms-main-content"
}
const _hoisted_17 = { class: "sms-main-header" }
const _hoisted_18 = { class: "sms-main-header__info" }
const _hoisted_19 = { class: "sms-main-header__name" }
const _hoisted_20 = { class: "sms-main-header__phone-wrapper" }
const _hoisted_21 = { class: "sms-main-header__phone" }
const _hoisted_22 = {
  key: 0,
  class: "sms-state-message sms-loading-state"
}
const _hoisted_23 = {
  key: 1,
  class: "sms-state-message sms-error-state"
}
const _hoisted_24 = {
  key: 2,
  class: "messages-list"
}
const _hoisted_25 = { class: "message-content" }
const _hoisted_26 = { class: "message-meta" }
const _hoisted_27 = { class: "timestamp" }
const _hoisted_28 = {
  key: 3,
  class: "sms-state-message sms-empty-state"
}
const _hoisted_29 = { class: "sms-composer" }
const _hoisted_30 = { class: "sms-composer__ai-buttons-wrapper" }
const _hoisted_31 = ["disabled", "title"]
const _hoisted_32 = ["disabled", "title"]
const _hoisted_33 = ["disabled", "title"]
const _hoisted_34 = ["disabled", "title"]
const _hoisted_35 = { class: "sms-composer__editor-wrapper" }
const _hoisted_36 = ["onKeydown"]
const _hoisted_37 = { class: "sms-composer__footer" }
const _hoisted_38 = { class: "sms-composer__footer-left" }
const _hoisted_39 = { class: "sms-composer__char-counter" }
const _hoisted_40 = { class: "sms-composer__footer-inline-tools" }
const _hoisted_41 = { class: "sms-composer__popover-content" }
const _hoisted_42 = { class: "sms-composer__link-field-wrapper" }
const _hoisted_43 = { class: "sms-composer__link-field-wrapper sms-composer__link-field-wrapper--url" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]

import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount } from "vue";
import { useToast } from "@/composables/ui/useToast";
import { Icon } from "@iconify/vue";
import { useRouter } from "vue-router";
import { Button } from "@/components/ui";
import LoadingBars from "@/components/ui/LoadingBars.vue";
import ConversationList from "@/components/bucket/interactions/ConversationList.vue";
import OutreachCueCards from "@/components/bucket/ai/OutreachCueCards.vue";
import EmojiPicker from "@/components/socials/EmojiPicker.vue";
import AiRefinePopover from "@/components/socials/AiRefinePopover.vue";
import { useResolvedAiPrompts } from "@/composables/useAiPrompts";
import StartSMSChatModal from "@/components/sms/StartSMSChatModal.vue";
import ActionConfirmationModal from "@/components/modal/ActionConfirmationModal.vue";
import { useSendSMS } from "@/composables/sms/useSendSMS";
import {
  useContactSMSConversations,
  useSMSConversationMessages,
  useCreateSMSConversation,
  type SMSConversation,
} from "@/composables/sms";
import { useSMSSocketListeners } from "@/composables/sms/useSMSSocketListeners";
import { useBillingStatus, USAGE_BLOCKED_TOOLTIP } from "@/composables/billing/useBillingStatus";
import { GET_PHONE_NUMBERS } from "@/store/action-types";
import { useQueryClient } from "@tanstack/vue-query";
import { useContactData } from "@/composables/contacts/useContactData";
import { useStore } from "vuex";
import { getFriendlyTwilioErrorMessage } from "@/utils/twilioErrors";
import AIGenerationService from "@/services/ai/ai-generation";
import IcpPicker from "@/components/ui/IcpPicker.vue";
import { useIcpPicker } from "@/composables/ui/useIcpPicker";
import { useMessageDraft } from "@/composables/messages/useMessageDraft";
import { normalizeSMSMessages } from "@/utils/conversationNormalizer";
import { SETTINGS_CALL_PHONE_NUMBERS_ROUTE } from "@/router/routes";

interface Props {
  selectedBucket: any;
  contact?: any;
  isActive: boolean;
  isChannelsLoading?: boolean;
  icps?: Array<{ id: string; name: string; isDefault?: boolean }>;
  icpLoading?: boolean;
  pendingCueCardContent?: any;
}

const maxChars = 1600;

export default /*@__PURE__*/_defineComponent({
  __name: 'SMSInteractionPanel',
  props: {
    selectedBucket: {},
    contact: {},
    isActive: { type: Boolean },
    isChannelsLoading: { type: Boolean, default: false },
    icps: { default: () => [] },
    icpLoading: { type: Boolean, default: false },
    pendingCueCardContent: { default: null }
  },
  emits: ["refresh-conversations", "message-sent", "show-edit-contact-modal", "open-ai-personalization", "switch-channel", "content-applied"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $toast = useToast();
const store = useStore();
const router = useRouter();

const { showUsageBasedFeaturesModalOnce, isUsageBlocked } = useBillingStatus();

const queryClient = useQueryClient();
const contactIdRef = ref<string | null>(null);

// Get organization ID from store
const organizationId = computed(() => store.getters.user?.organizationId || "");

// Get phone numbers from Vuex store
const storePhoneNumbers = computed(() => store.getters.phoneNumbers);
const isLoadingPhoneNumbers = computed(() => storePhoneNumbers.value?.isLoading || false);

// Fetch phone numbers if not already loaded
const fetchPhoneNumbers = () => {
  if (organizationId.value && !storePhoneNumbers.value?.data?.length) {
    store.dispatch(GET_PHONE_NUMBERS, { organizationId: organizationId.value });
  }
};
const selectedConversationId = ref<string | null>(null);

// View state
const showDetailView = ref(false);
const selectedConversation = ref<SMSConversation | null>(null);
const showStartChatModal = ref(false);
const initialModalMessage = ref("");

const {
  data: conversationsData,
  isLoading: isLoadingConversations,
  isPending: isPendingConversations,
  isError: isConversationsError,
  refetch: refetchConversations,
} = useContactSMSConversations(contactIdRef);

const {
  data: messagesData,
  isLoading: isLoadingMessages,
  isError: isMessagesError,
  refetch: refetchMessages,
} = useSMSConversationMessages(selectedConversationId);

const { mutate: sendSMS, isPending: isSending } = useSendSMS();
const { mutate: createConversation, isPending: isCreatingConversation } =
  useCreateSMSConversation();

const { fetchDraft, scheduleSave, flushSave, clearDraft } = useMessageDraft("sms");
let currentDraftConversationId = "";

// Message composer state
const messagesContainer = ref<HTMLElement | null>(null);
const textareaRef = ref<HTMLTextAreaElement | null>(null);
const messageBody = ref("");
const charCount = ref(0);
const isGeneratingAI = ref(false);
const generatingAction = ref<string | null>(null);
const showAiPanel = ref(false);
const showAiComposePanel = ref(false);
const isGeneratingAiCustom = ref(false);
const aiRefineButtonRef = ref<HTMLElement | null>(null);
const aiComposeButtonRef = ref<HTMLElement | null>(null);
const pendingComposeIcpId = ref<string | undefined>(undefined);
const resolvedAiPromptsQuery = useResolvedAiPrompts();

// Emoji and link popover state
const showEmojiPopover = ref(false);
const showLinkPopover = ref(false);
const linkText = ref("");
const linkUrl = ref("");
const linkInputRef = ref<HTMLInputElement | null>(null);
const linkPopoverRef = ref<HTMLElement | null>(null);
const linkPopoverWrapperRef = ref<HTMLElement | null>(null);
const sendButtonRef = ref<HTMLElement | null>(null);
const popoverStyle = ref<{ bottom?: string; right?: string; left?: string }>({});

// Computed: Messages sorted for chat view (oldest first)
const messages = computed(() => {
  if (!messagesData.value?.messages) return [];
  // Messages come from API already sorted ASC (oldest first)
  return messagesData.value.messages;
});

// Computed: Format conversations for list
const formattedConversations = computed(() => {
  if (!conversationsData.value) return [];
  return (conversationsData.value as SMSConversation[]).map((conv) => {
    const contactName = conv.contact
      ? [conv.contact.fname, conv.contact.lname].filter(Boolean).join(" ") || "Unknown Contact"
      : "Unknown Contact";
    return {
      id: conv.id,
      title: contactName,
      subtitle: conv.contactPhoneNumber,
      lastMessage: conv.lastMessagePreview || "",
      lastMessageAt: conv.lastMessageAt || conv.createdAt,
      unreadCount: conv.unreadCount || 0,
      lastMessageDirection: conv.lastMessageDirection || null,
    };
  });
});

const smsICPOptions = computed(() => {
  const list = Array.isArray(props.icps) ? props.icps : [];
  return [
    { value: "", label: "Select ICP for SMS" },
    ...list.map((icp) => ({
      value: icp.id,
      label: icp.isDefault ? `${icp.name} (Default)` : icp.name,
    })),
  ];
});

const orgPhoneNumbers = computed(() => {
  const data = storePhoneNumbers.value?.data;
  if (!data || !Array.isArray(data)) return [];
  return data.map((phone: any) => ({
    id: phone.id,
    number: phone.number,
    region: phone.region,
    city: phone.city,
  }));
});

const hasOrgPhoneNumbers = computed(() => {
  return orgPhoneNumbers.value && orgPhoneNumbers.value.length > 0;
});

const contactPhoneNumbers = computed(() => {
  const { computeContactPhoneNumbers } = useContactData(store);
  const phones = computeContactPhoneNumbers({
    contact: props.contact ?? props.selectedBucket?.contact,
  });
  return phones.map((p: any) => ({
    id: p.id,
    label: p.type || "Phone",
    number: p.number,
  }));
});

const hasValidPhoneNumber = computed(() => {
  return contactPhoneNumbers.value && contactPhoneNumbers.value.length > 0;
});

const canSend = computed(() => {
  return (
    messageBody.value.trim().length > 0 &&
    !isSending.value &&
    charCount.value <= maxChars &&
    selectedConversation.value
  );
});

const updateCharCount = () => {
  charCount.value = messageBody.value.length;
};

watch(
  messageBody,
  () => {
    updateCharCount();
  },
  { immediate: true }
);

const loadSMSDraftForConversation = async (conversationId: string) => {
  currentDraftConversationId = conversationId;
  messageBody.value = "";
  if (!conversationId) return;
  const draftContent = await fetchDraft(conversationId);
  if (currentDraftConversationId === conversationId && draftContent) {
    messageBody.value = draftContent;
  }
};

watch(selectedConversationId, (newId, oldId) => {
  if (oldId) {
    flushSave(oldId, messageBody.value);
  }
  loadSMSDraftForConversation(newId || "");
});

watch(messageBody, (newVal) => {
  const conversationId = selectedConversationId.value;
  if (!conversationId) return;
  scheduleSave(conversationId, newVal);
});

const formatTimestamp = (timestamp: string | Date) => {
  if (!timestamp) return "";

  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return "";

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  if (diffMs < 0) return "Just now";

  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays}d ago`;

  const isCurrentYear = date.getFullYear() === now.getFullYear();
  if (isCurrentYear) {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  }

  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

const getStatusIcon = (status: string) => {
  switch (status) {
    case "delivered":
    case "sent":
      return "mdi:check";
    case "failed":
    case "undelivered":
      return "mdi:alert-circle";
    case "queued":
    case "accepted":
    case "sending":
      return "mdi:clock-outline";
    default:
      return "mdi:check";
  }
};

const scrollToBottom = () => {
  if (messagesContainer.value) {
    messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
  }
};

function applySMSContent(content: string) {
  messageBody.value = content;
  updateCharCount();
  $toast?.success("SMS message loaded from cue card");
}

function handleUseCueCardContent(payload: { channel: string; content: string; subject?: string }) {
  if (payload.channel === "sms" && payload.content) {
    if (showDetailView.value && selectedConversation.value) {
      applySMSContent(payload.content);
    } else {
      initialModalMessage.value = payload.content;
      showStartChatModal.value = true;
    }
  } else {
    emit("switch-channel", payload);
  }
}

// Handle conversation selection
const handleConversationSelected = (conversation: any) => {
  const fullConversation = conversationsData.value?.find((c) => c.id === conversation.id);
  if (fullConversation) {
    selectedConversationId.value = conversation.id;
    selectedConversation.value = fullConversation;
    showDetailView.value = true;

    if (fullConversation.unreadCount > 0) {
      const prevUnread = fullConversation.unreadCount;
      const contactId = props.selectedBucket?.contact?.id;

      queryClient.setQueryData(["sms-conversations", contactIdRef.value], (old: any) => {
        if (!old) return old;
        return old.map((c: any) => (c.id === conversation.id ? { ...c, unreadCount: 0 } : c));
      });

      if (contactId) {
        queryClient.setQueryData(["interactionCounts", contactId], (old: any) => {
          if (!old?.sms) return old;
          return {
            ...old,
            sms: {
              ...old.sms,
              unread: Math.max(0, (old.sms.unread || 0) - prevUnread),
            },
          };
        });
      }

      // Buckets table's Activity column is a separate bulk query, keyed by the page's
      // contactIds — the optimistic cache writes above don't touch it, so invalidate it too.
      queryClient.invalidateQueries({ queryKey: ["engagement-summary"] });
    }
  }
};

const handleBackToList = () => {
  selectedConversationId.value = null;
  selectedConversation.value = null;
  showDetailView.value = false;
  refetchConversations();
};

// Navigate to purchase phone number page
const navigateToPurchaseNumber = () => {
  router.push({ name: SETTINGS_CALL_PHONE_NUMBERS_ROUTE });
};

// Handle create chat
const handleCreateChat = async (request: {
  contactId: string;
  phoneNumberId: string;
  contactPhoneNumber: string;
  contactPhoneId?: string;
  message?: string;
}) => {
  const { message, ...createRequest } = request;

  createConversation(createRequest, {
    onSuccess: (newConversation) => {
      showStartChatModal.value = false;
      $toast?.success("Conversation created");

      // Navigate to the new conversation
      selectedConversationId.value = newConversation.id;
      selectedConversation.value = newConversation;
      showDetailView.value = true;

      // Refetch conversations list
      refetchConversations();

      // Send initial message if provided
      if (message) {
        showUsageBasedFeaturesModalOnce("sms", async () => {
          sendSMS(
            {
              to: request.contactPhoneNumber,
              body: message,
              contactId: request.contactId,
              conversationId: newConversation.id,
              phoneNumberId: request.phoneNumberId,
              contactPhoneId: request.contactPhoneId,
            },
            {
              onSuccess: async () => {
                refetchMessages();
                refetchConversations();
                await nextTick();
                scrollToBottom();
              },
              onError: (error: any) => {
                console.error("Failed to send initial SMS:", error);
                if (!error?.absorbedButRecoverable) {
                  const friendlyMessage = getFriendlyTwilioErrorMessage(error);
                  $toast?.error(friendlyMessage);
                }
              },
            }
          );
        });
      }
    },
    onError: (error: any) => {
      console.error("Failed to create conversation:", error);
      $toast?.error(error.response?.data?.message || "Failed to create conversation");
    },
  });
};

const showAiActionConfirm = ref(false);
const pendingAiActionMode = ref<"reply" | "followup" | null>(null);
const pendingAiActionIcpId = ref<string | undefined>(undefined);

const aiActionConfirmTitle = computed(() =>
  pendingAiActionMode.value === "followup" ? "Generate AI Follow-up" : "Generate AI Reply"
);
const aiActionConfirmMessage = computed(() =>
  pendingAiActionMode.value === "followup"
    ? "This will generate an AI-written follow-up message. Continue?"
    : "This will generate an AI-written reply. Continue?"
);

const confirmAiAction = () => {
  if (pendingAiActionMode.value === "reply") doSMSAiReply(pendingAiActionIcpId.value);
  else if (pendingAiActionMode.value === "followup") doSMSAiFollowup(pendingAiActionIcpId.value);
  showAiActionConfirm.value = false;
  pendingAiActionMode.value = null;
};

const cancelAiAction = () => {
  showAiActionConfirm.value = false;
  pendingAiActionMode.value = null;
};

const { showIcpPicker, icpPickerMode, triggerAiAction, selectIcp, dismissIcpPicker } = useIcpPicker(
  (mode, icpId) => {
    if (mode === "reply" || mode === "followup") {
      pendingAiActionMode.value = mode;
      pendingAiActionIcpId.value = icpId;
      showAiActionConfirm.value = true;
    } else {
      pendingComposeIcpId.value = icpId;
      showAiPanel.value = false;
      showAiComposePanel.value = true;
    }
  }
);

const toggleAiRefinePanel = () => {
  showAiComposePanel.value = false;
  showAiPanel.value = !showAiPanel.value;
};

const handleSMSAiReply = async () => {
  if (isGeneratingAI.value) return;
  triggerAiAction("reply", props.icps);
};

const doSMSAiReply = async (icpId?: string) => {
  if (isGeneratingAI.value) return;

  await showUsageBasedFeaturesModalOnce("ai_generation", async () => {
    isGeneratingAI.value = true;
    generatingAction.value = "reply";
    try {
      const conversationHistory = normalizeSMSMessages(messages.value || []);

      const contactId = props.selectedBucket?.contact?.id;

      const response = await AIGenerationService.generateReply({
        contactId,
        icpId,
        channel: "sms",
        conversationHistory,
      });

      messageBody.value = response.body.replace(/<br\s*\/?>/gi, "\n");
      updateCharCount();

      $toast?.success("AI reply generated");
    } catch (error) {
      $toast?.error("Failed to generate AI response");
    } finally {
      isGeneratingAI.value = false;
      generatingAction.value = null;
    }
  });
};

const handleSMSAiFollowup = async () => {
  if (isGeneratingAI.value) return;
  triggerAiAction("followup", props.icps);
};

const doSMSAiFollowup = async (icpId?: string) => {
  if (isGeneratingAI.value) return;

  await showUsageBasedFeaturesModalOnce("ai_generation", async () => {
    isGeneratingAI.value = true;
    generatingAction.value = "followup";
    try {
      const conversationHistory = normalizeSMSMessages(messages.value || []);

      const contactId = props.selectedBucket?.contact?.id;

      const response = await AIGenerationService.generateFollowup({
        contactId,
        icpId,
        channel: "sms",
        conversationHistory,
      });

      messageBody.value = response.body.replace(/<br\s*\/?>/gi, "\n");
      updateCharCount();

      $toast?.success("AI follow-up generated");
    } catch (error) {
      $toast?.error("Failed to generate AI response");
    } finally {
      isGeneratingAI.value = false;
      generatingAction.value = null;
    }
  });
};

const handleSMSAiCompose = async () => {
  if (isGeneratingAI.value) return;
  triggerAiAction("compose", props.icps);
};

const doSMSAiCompose = async (icpId?: string, customInstructions?: string) => {
  if (isGeneratingAI.value) return;

  await showUsageBasedFeaturesModalOnce("ai_generation", async () => {
    isGeneratingAI.value = true;
    generatingAction.value = "compose";
    try {
      const conversationHistory = normalizeSMSMessages(messages.value || []);

      const contactId = props.selectedBucket?.contact?.id;

      const response = await AIGenerationService.generateCompose({
        contactId,
        icpId,
        channel: "sms",
        conversationHistory,
        customInstructions,
        aiPromptCompose: resolvedAiPromptsQuery.composeAiPrompt.value,
      });

      messageBody.value = response.body.replace(/<br\s*\/?>/gi, "\n");
      updateCharCount();
      showAiComposePanel.value = false;

      $toast?.success("AI message composed");
    } catch (error) {
      $toast?.error("Failed to generate AI response");
    } finally {
      isGeneratingAI.value = false;
      generatingAction.value = null;
    }
  });
};

const handleAiComposeGenerate = (payload: { customInstructions: string }) => {
  doSMSAiCompose(pendingComposeIcpId.value, payload.customInstructions);
};

const handleAiCustomizationGenerate = async (payload: {
  customInstructions: string;
  attachments: File[];
}) => {
  if (isGeneratingAiCustom.value) return;

  await showUsageBasedFeaturesModalOnce("ai_generation", async () => {
    isGeneratingAiCustom.value = true;
    try {
      const contactId = props.selectedBucket?.contact?.id;
      const defaultIcp = props.icps?.find((i) => i.isDefault);

      const response = await AIGenerationService.generateRefine({
        contactId,
        icpId: defaultIcp?.id,
        channel: "sms",
        currentDraft: messageBody.value,
        customInstructions: payload.customInstructions,
        files: payload.attachments,
      });

      messageBody.value = response.body.replace(/<br\s*\/?>/gi, "\n");
      updateCharCount();
      showAiPanel.value = false;
      $toast?.success("AI message refined");
    } catch (error) {
      $toast?.error("Failed to refine AI message");
    } finally {
      isGeneratingAiCustom.value = false;
    }
  });
};

const handleSend = async () => {
  if (!canSend.value || !selectedConversation.value) return;

  await showUsageBasedFeaturesModalOnce("sms", async () => {
    const body = messageBody.value.trim();
    const contactId = props.selectedBucket?.contact?.id;

    if (!contactId) {
      $toast?.error("Contact ID is missing");
      return;
    }

    // Optimistic update via TanStack Query cache
    const queryKey = ["sms-conversation-messages", selectedConversation.value!.id];
    const previousData = queryClient.getQueryData(queryKey) as any;
    if (previousData) {
      queryClient.setQueryData(queryKey, {
        ...previousData,
        messages: [
          ...(previousData.messages || []),
          {
            id: `temp-${Date.now()}`,
            body,
            direction: "outbound",
            status: "sending",
            createdAt: new Date().toISOString(),
            sentAt: new Date().toISOString(),
            isPending: true,
          },
        ],
      });
    }
    clearDraft(selectedConversation.value!.id);
    messageBody.value = "";
    charCount.value = 0;
    await nextTick();
    scrollToBottom();

    sendSMS(
      {
        to: selectedConversation.value!.contactPhoneNumber,
        body,
        contactId,
        conversationId: selectedConversation.value!.id,
        phoneNumberId: selectedConversation.value!.phoneNumberId,
        contactPhoneId: selectedConversation.value!.contactPhoneId,
      },
      {
        onSuccess: () => {
          refetchMessages();
          refetchConversations();
          emit("message-sent");
        },
        onError: (error: any) => {
          console.error("Failed to send SMS:", error);
          if (previousData) {
            queryClient.setQueryData(queryKey, previousData);
          }
          if (!error?.absorbedButRecoverable) {
            const friendlyMessage = getFriendlyTwilioErrorMessage(error);
            $toast?.error(friendlyMessage);
          }
        },
      }
    );
  });
};

// Watch for contact changes
watch(
  () => props.selectedBucket?.contact?.id,
  (newContactId) => {
    contactIdRef.value = newContactId || null;
    // Reset view when contact changes
    showDetailView.value = false;
    selectedConversationId.value = null;
    selectedConversation.value = null;
  },
  { immediate: true }
);

watch(
  () => props.isActive,
  async (isActive) => {
    if (isActive) {
      // Fetch phone numbers if not loaded
      fetchPhoneNumbers();

      if (contactIdRef.value) {
        await refetchConversations();
        if (selectedConversationId.value) {
          await refetchMessages();
          await nextTick();
          scrollToBottom();
        }
      }
    }
  },
  { immediate: true }
);

// Watch messages to scroll to bottom (only when near bottom or initial)
watch(
  () => messages.value?.length,
  (newLen, oldLen) => {
    if (!showDetailView.value) return;
    if (!oldLen && newLen) {
      scrollToBottom();
      return;
    }
    if (newLen && oldLen && newLen > oldLen && messagesContainer.value) {
      const { scrollTop, scrollHeight, clientHeight } = messagesContainer.value;
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 150;
      if (isNearBottom) {
        scrollToBottom();
      }
    }
  },
  { flush: "post" }
);

// Setup socket listeners for real-time updates
useSMSSocketListeners({
  onSMSReceived: (data) => {
    if (data.contactId === contactIdRef.value) {
      queryClient.invalidateQueries({ queryKey: ["sms-conversations", contactIdRef.value] });
      if (data.conversationId && data.conversationId === selectedConversationId.value) {
        queryClient.invalidateQueries({
          queryKey: ["sms-conversation-messages", selectedConversationId.value],
        });
        nextTick(() => scrollToBottom());
      }
      emit("refresh-conversations");
    }
  },
  onSMSSent: (data) => {
    if (data.contactId === contactIdRef.value) {
      queryClient.invalidateQueries({ queryKey: ["sms-conversations", contactIdRef.value] });
      if (data.conversationId && data.conversationId === selectedConversationId.value) {
        queryClient.invalidateQueries({
          queryKey: ["sms-conversation-messages", selectedConversationId.value],
        });
        nextTick(() => scrollToBottom());
      }
      emit("refresh-conversations");
    }
  },
  onSMSStatus: (data) => {
    if (data.contactId === contactIdRef.value) {
      queryClient.invalidateQueries({ queryKey: ["sms-conversations", contactIdRef.value] });
      if (data.conversationId && data.conversationId === selectedConversationId.value) {
        queryClient.invalidateQueries({
          queryKey: ["sms-conversation-messages", selectedConversationId.value],
        });
      }
      emit("refresh-conversations");
    }
  },
});

// Link popover methods
const toggleLinkPopover = () => {
  if (showLinkPopover.value) {
    closeLinkPopover();
  } else {
    closeAllPopovers();

    if (textareaRef.value) {
      const selectionStart = textareaRef.value.selectionStart;
      const selectionEnd = textareaRef.value.selectionEnd;
      if (selectionStart !== selectionEnd) {
        linkText.value = messageBody.value.substring(selectionStart, selectionEnd);
      } else {
        linkText.value = "";
      }
    }

    showLinkPopover.value = true;
    nextTick(() => {
      if (linkPopoverWrapperRef.value) {
        const wrapperRect = linkPopoverWrapperRef.value.getBoundingClientRect();
        const popoverWidth = 240;
        const spacing = 8;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        let right: string | undefined = undefined;
        let left: string | undefined = undefined;
        const rightPosition = viewportWidth - wrapperRect.right;

        if (wrapperRect.right - popoverWidth < 16) {
          left = "16px";
          right = undefined;
        } else {
          right = `${rightPosition}px`;
          left = undefined;
        }

        const bottom = `${viewportHeight - wrapperRect.top + spacing}px`;

        popoverStyle.value = {
          bottom,
          right,
          left,
        };
      }

      if (linkInputRef.value) {
        linkInputRef.value.focus();
      }
    });
  }
};

const closeLinkPopover = () => {
  showLinkPopover.value = false;
  linkUrl.value = "";
  linkText.value = "";
};

const insertLink = () => {
  if (!textareaRef.value) return;

  if (!linkUrl.value || linkUrl.value.trim() === "") {
    return;
  }

  try {
    const selectionStart = textareaRef.value.selectionStart;
    const selectionEnd = textareaRef.value.selectionEnd;

    let url = linkUrl.value.trim();
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }

    const text = linkText.value.trim() || url;
    const linkString = text ? `${text} (${url})` : url;

    const beforeText = messageBody.value.substring(0, selectionStart);
    const afterText = messageBody.value.substring(selectionEnd);
    messageBody.value = beforeText + linkString + afterText;

    updateCharCount();

    nextTick(() => {
      if (textareaRef.value) {
        const newCursorPos = selectionStart + linkString.length;
        textareaRef.value.setSelectionRange(newCursorPos, newCursorPos);
        textareaRef.value.focus();
      }
    });

    closeLinkPopover();
  } catch (error) {
    console.error("Error inserting link:", error);
    closeLinkPopover();
  }
};

const toggleEmojiPopover = () => {
  if (showEmojiPopover.value) {
    showEmojiPopover.value = false;
  } else {
    closeAllPopovers();
    showEmojiPopover.value = true;
  }
};

const closeEmojiPopover = () => {
  showEmojiPopover.value = false;
};

const handleEmojiSelect = (emoji: any) => {
  if (!textareaRef.value) {
    closeEmojiPopover();
    return;
  }

  try {
    const selectionStart = textareaRef.value.selectionStart;
    const selectionEnd = textareaRef.value.selectionEnd;

    const emojiChar = emoji.emoji || emoji.native || emoji;

    const beforeText = messageBody.value.substring(0, selectionStart);
    const afterText = messageBody.value.substring(selectionEnd);
    messageBody.value = beforeText + emojiChar + afterText;

    updateCharCount();

    nextTick(() => {
      if (textareaRef.value) {
        const newCursorPos = selectionStart + emojiChar.length;
        textareaRef.value.setSelectionRange(newCursorPos, newCursorPos);
        textareaRef.value.focus();
      }
    });

    closeEmojiPopover();
  } catch (error) {
    console.error("Error inserting emoji:", error);
    closeEmojiPopover();
  }
};

const closeAllPopovers = () => {
  showLinkPopover.value = false;
  showEmojiPopover.value = false;
};

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement;

  if (
    showEmojiPopover.value &&
    !target.closest(".sms-composer__emoji-container") &&
    !target.closest("[title='Insert emoji']")
  ) {
    closeEmojiPopover();
  }

  if (showLinkPopover.value && linkPopoverRef.value && !linkPopoverRef.value.contains(target)) {
    closeLinkPopover();
  }
};

onMounted(() => {
  if (props.selectedBucket?.contact?.id) {
    contactIdRef.value = props.selectedBucket.contact.id;
  }

  // Fetch phone numbers if not loaded
  fetchPhoneNumbers();

  if (typeof window !== "undefined") {
    document.addEventListener("click", handleClickOutside);
  }
});

onBeforeUnmount(() => {
  if (typeof window !== "undefined") {
    document.removeEventListener("click", handleClickOutside);
  }
  if (selectedConversationId.value) {
    flushSave(selectedConversationId.value, messageBody.value);
  }
});

watch(
  () => props.pendingCueCardContent,
  (payload) => {
    if (payload && payload.channel === "sms" && payload.content) {
      if (showDetailView.value && selectedConversation.value) {
        applySMSContent(payload.content);
      } else {
        initialModalMessage.value = payload.content;
        showStartChatModal.value = true;
      }
      emit("content-applied");
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.isChannelsLoading || isLoadingPhoneNumbers.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(LoadingBars, { size: "sm" })
          ]))
        : (!hasOrgPhoneNumbers.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:message-off-outline",
                  class: "sms-empty-state__icon sms-empty-state__icon--sm"
                }),
                _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "sms-empty-state__title" }, "No SMS Number", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "sms-empty-state__message" }, " Purchase a Twilio phone number to start sending SMS messages. ", -1)),
                _createVNode(_unref(Button), {
                  variant: "primary",
                  size: "sm",
                  icon: "mdi:plus",
                  onClick: navigateToPurchaseNumber
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Purchase Number ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]))
          : (!hasValidPhoneNumber.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:phone-off-outline",
                    class: "sms-empty-state__icon sms-empty-state__icon--sm"
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "sms-empty-state__title" }, "No Contact Phone", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("p", { class: "sms-empty-state__message" }, " Add a phone number to this contact to send SMS messages. ", -1)),
                  _createVNode(_unref(Button), {
                    variant: "primary",
                    size: "sm",
                    icon: "mdi:pencil-outline",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-edit-contact-modal')))
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" Edit Contact ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(OutreachCueCards, {
                  "icp-options": smsICPOptions.value,
                  "icp-loading": props.icpLoading,
                  "contact-id": __props.selectedBucket?.contact?.id || '',
                  "contact-name": 
            [__props.selectedBucket?.contact?.fname, __props.selectedBucket?.contact?.lname]
              .filter(Boolean)
              .join(' ')
          ,
                  "full-width": true,
                  onUseContent: handleUseCueCardContent
                }, null, 8, ["icp-options", "icp-loading", "contact-id", "contact-name"]),
                (!showDetailView.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_unref(Button), {
                          variant: "primary",
                          size: "sm",
                          icon: "mdi:message-plus",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showStartChatModal.value = true)),
                          block: ""
                        }, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode(" Start New Chat ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      (_unref(isLoadingConversations) || (_unref(isPendingConversations) && !!contactIdRef.value))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(LoadingBars, { size: "sm" })
                          ]))
                        : (_unref(isConversationsError))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_unref(Icon), {
                                  icon: "mdi:alert-circle-outline",
                                  class: "sms-empty-state__icon"
                                }),
                                _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "sms-empty-state__title" }, "Failed to load conversations", -1)),
                                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "sms-empty-state__message" }, "Something went wrong. Please try again.", -1)),
                                _createVNode(_unref(Button), {
                                  variant: "outline",
                                  size: "sm",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(refetchConversations)()))
                                }, {
                                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                    _createTextVNode(" Retry ", -1)
                                  ]))]),
                                  _: 1
                                })
                              ])
                            ]))
                          : (formattedConversations.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:message-text-outline",
                                    class: "sms-empty-state__icon"
                                  }),
                                  _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "sms-empty-state__title" }, "No Conversations", -1)),
                                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "sms-empty-state__message" }, " Start a new chat to begin messaging this contact. ", -1))
                                ])
                              ]))
                            : (_openBlock(), _createBlock(ConversationList, {
                                key: 3,
                                conversations: formattedConversations.value as any,
                                "selected-conversation-id": selectedConversationId.value ?? undefined,
                                "is-loading": _unref(isLoadingConversations),
                                type: "sms",
                                "show-search": false,
                                "show-header": false,
                                onConversationSelected: handleConversationSelected
                              }, null, 8, ["conversations", "selected-conversation-id", "is-loading"]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          class: "sms-main-header__back-btn",
                          onClick: handleBackToList
                        }, [
                          _createVNode(_unref(Icon), { icon: "mdi:chevron-left" })
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(selectedConversation.value?.contact
                  ? [selectedConversation.value.contact.fname, selectedConversation.value.contact.lname]
                      .filter(Boolean)
                      .join(" ") || "Unknown Contact"
                  : "Unknown Contact"), 1),
                          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "sms-main-header__separator" }, "•", -1)),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_unref(Icon), {
                              icon: "mdi:phone-outline",
                              class: "sms-main-header__phone-icon"
                            }),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(selectedConversation.value?.contactPhoneNumber), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "sms-messages-container",
                        ref_key: "messagesContainer",
                        ref: messagesContainer
                      }, [
                        (_unref(isLoadingMessages))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(LoadingBars, { size: "sm" })
                            ]))
                          : (_unref(isMessagesError))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createVNode(_unref(Icon), {
                                  icon: "mdi:alert-circle-outline",
                                  class: "sms-state-icon"
                                }),
                                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "sms-state-text" }, "Failed to load messages", -1)),
                                _createElementVNode("button", {
                                  class: "retry-btn",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(refetchMessages)()))
                                }, "Retry")
                              ]))
                            : (messages.value && messages.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: message.id,
                                      class: _normalizeClass(['message-bubble', message.direction === 'outbound' ? 'sent' : 'received'])
                                    }, [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("p", null, _toDisplayString(message.body), 1),
                                        _createElementVNode("div", _hoisted_26, [
                                          _createElementVNode("span", _hoisted_27, _toDisplayString(formatTimestamp(message.sentAt)), 1),
                                          (message.direction === 'outbound')
                                            ? (_openBlock(), _createBlock(_unref(Icon), {
                                                key: 0,
                                                icon: getStatusIcon(message.status),
                                                class: _normalizeClass(['status-icon', `status-${message.status}`]),
                                                title: message.status
                                              }, null, 8, ["icon", "class", "title"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ], 2))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:message-text-outline",
                                    class: "sms-state-icon"
                                  }),
                                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "sms-state-text" }, "No messages yet. Start the conversation!", -1))
                                ]))
                      ], 512),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(IcpPicker, {
                          show: _unref(showIcpPicker),
                          mode: _unref(icpPickerMode),
                          icps: __props.icps,
                          class: "sms-composer__icp-picker-positioned",
                          onSelect: _unref(selectIcp),
                          onDismiss: _unref(dismissIcpPicker)
                        }, null, 8, ["show", "mode", "icps", "onSelect", "onDismiss"]),
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            ref_key: "aiComposeButtonRef",
                            ref: aiComposeButtonRef,
                            type: "button",
                            class: "sms-composer__ai-btn sms-composer__ai-btn--compose",
                            disabled: isGeneratingAI.value || _unref(isUsageBlocked),
                            title: _unref(isUsageBlocked) ? '' : isGeneratingAI.value ? 'Generating...' : 'AI Compose',
                            onClick: _withModifiers(handleSMSAiCompose, ["stop"])
                          }, [
                            (isGeneratingAI.value && generatingAction.value === 'compose')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "sms-composer__ai-spinner" }, null, -1)),
                                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "sms-composer__ai-btn-text" }, "Generating...", -1))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "sms-composer__ai-btn-text" }, "AI Compose", -1))
                                ], 64))
                          ], 8, _hoisted_31)), [
                            [_directive_tooltip, {
                  content: _unref(USAGE_BLOCKED_TOOLTIP),
                  disabled: !_unref(isUsageBlocked) || isGeneratingAI.value,
                }]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "sms-composer__ai-btn sms-composer__ai-btn--reply",
                            disabled: isGeneratingAI.value || _unref(isUsageBlocked),
                            title: _unref(isUsageBlocked) ? '' : isGeneratingAI.value ? 'Generating...' : 'AI Reply',
                            onClick: _withModifiers(handleSMSAiReply, ["stop"])
                          }, [
                            (isGeneratingAI.value && generatingAction.value === 'reply')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "sms-composer__ai-spinner" }, null, -1)),
                                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "sms-composer__ai-btn-text" }, "Generating...", -1))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                                  _cache[31] || (_cache[31] = _createElementVNode("span", { class: "sms-composer__ai-btn-text" }, "AI Reply", -1))
                                ], 64))
                          ], 8, _hoisted_32)), [
                            [_directive_tooltip, {
                  content: _unref(USAGE_BLOCKED_TOOLTIP),
                  disabled: !_unref(isUsageBlocked) || isGeneratingAI.value,
                }]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "sms-composer__ai-btn sms-composer__ai-btn--followup",
                            disabled: isGeneratingAI.value || _unref(isUsageBlocked),
                            title: _unref(isUsageBlocked) ? '' : isGeneratingAI.value ? 'Generating...' : 'AI Follow-up',
                            onClick: _withModifiers(handleSMSAiFollowup, ["stop"])
                          }, [
                            (isGeneratingAI.value && generatingAction.value === 'followup')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[32] || (_cache[32] = _createElementVNode("span", { class: "sms-composer__ai-spinner" }, null, -1)),
                                  _cache[33] || (_cache[33] = _createElementVNode("span", { class: "sms-composer__ai-btn-text" }, "Generating...", -1))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                                  _cache[34] || (_cache[34] = _createElementVNode("span", { class: "sms-composer__ai-btn-text" }, "AI Follow-up", -1))
                                ], 64))
                          ], 8, _hoisted_33)), [
                            [_directive_tooltip, {
                  content: _unref(USAGE_BLOCKED_TOOLTIP),
                  disabled: !_unref(isUsageBlocked) || isGeneratingAI.value,
                }]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            ref_key: "aiRefineButtonRef",
                            ref: aiRefineButtonRef,
                            type: "button",
                            class: "sms-composer__ai-btn sms-composer__ai-btn--custom",
                            disabled: isGeneratingAI.value || isGeneratingAiCustom.value || _unref(isUsageBlocked),
                            title: _unref(isUsageBlocked) ? '' : isGeneratingAiCustom.value ? 'Generating...' : 'AI Refine',
                            onClick: _withModifiers(toggleAiRefinePanel, ["stop"])
                          }, [
                            _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "sms-composer__ai-btn-text" }, "AI Refine", -1))
                          ], 8, _hoisted_34)), [
                            [_directive_tooltip, {
                  content: _unref(USAGE_BLOCKED_TOOLTIP),
                  disabled: !_unref(isUsageBlocked) || isGeneratingAI.value || isGeneratingAiCustom.value,
                }]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("textarea", {
                            ref_key: "textareaRef",
                            ref: textareaRef,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((messageBody).value = $event)),
                            onInput: updateCharCount,
                            onKeydown: _withKeys(_withModifiers(handleSend, ["ctrl"]), ["enter"]),
                            placeholder: "Type your message...",
                            maxlength: 1600,
                            rows: "2",
                            class: "sms-composer__textarea"
                          }, null, 40, _hoisted_36), [
                            [_vModelText, messageBody.value]
                          ])
                        ]),
                        (showEmojiPopover.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "sms-composer__emoji-container",
                              onClick: _withModifiers(closeEmojiPopover, ["self"])
                            }, [
                              _createVNode(EmojiPicker, { onSelect: handleEmojiSelect })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(AiRefinePopover, {
                          show: showAiPanel.value,
                          "trigger-el": aiRefineButtonRef.value,
                          disabled: isGeneratingAiCustom.value,
                          onGenerate: handleAiCustomizationGenerate,
                          onClose: _cache[5] || (_cache[5] = ($event: any) => (showAiPanel.value = false))
                        }, null, 8, ["show", "trigger-el", "disabled"]),
                        _createVNode(AiRefinePopover, {
                          show: showAiComposePanel.value,
                          "trigger-el": aiComposeButtonRef.value,
                          disabled: isGeneratingAI.value && generatingAction.value === 'compose',
                          title: "AI Compose",
                          "generate-button-label": "Generate Message",
                          "show-attachments": false,
                          onGenerate: handleAiComposeGenerate,
                          onClose: _cache[6] || (_cache[6] = ($event: any) => (showAiComposePanel.value = false))
                        }, null, 8, ["show", "trigger-el", "disabled"]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", null, _toDisplayString(charCount.value) + "/" + _toDisplayString(maxChars), 1)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "sms-composer__footer-right",
                            ref_key: "sendButtonRef",
                            ref: sendButtonRef
                          }, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", {
                                class: "sms-composer__popover-wrapper",
                                ref_key: "linkPopoverWrapperRef",
                                ref: linkPopoverWrapperRef
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sms-composer__footer-icon-btn",
                                  title: "Insert link",
                                  onClick: _withModifiers(toggleLinkPopover, ["stop"])
                                }, [
                                  _createVNode(_unref(Icon), { icon: "mdi:link" })
                                ]),
                                (showLinkPopover.value)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      ref_key: "linkPopoverRef",
                                      ref: linkPopoverRef,
                                      class: "sms-composer__popover sms-composer__popover--link",
                                      style: _normalizeStyle(popoverStyle.value),
                                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                          _createVNode(_unref(Icon), {
                                            icon: "mdi:format-align-left",
                                            class: "sms-composer__link-field-icon"
                                          }),
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((linkText).value = $event)),
                                            type: "text",
                                            class: "sms-composer__link-input sms-composer__link-input--text",
                                            placeholder: "Text",
                                            onKeyup: [
                                              _withKeys(insertLink, ["enter"]),
                                              _withKeys(closeLinkPopover, ["esc"])
                                            ]
                                          }, null, 544), [
                                            [_vModelText, linkText.value]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_43, [
                                          _createVNode(_unref(Icon), {
                                            icon: "mdi:link",
                                            class: "sms-composer__link-field-icon"
                                          }),
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((linkUrl).value = $event)),
                                            type: "text",
                                            class: "sms-composer__link-input sms-composer__link-input--url",
                                            placeholder: "Type or paste a link",
                                            onKeyup: [
                                              _withKeys(insertLink, ["enter"]),
                                              _withKeys(closeLinkPopover, ["esc"])
                                            ],
                                            ref_key: "linkInputRef",
                                            ref: linkInputRef
                                          }, null, 544), [
                                            [_vModelText, linkUrl.value]
                                          ]),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "sms-composer__link-apply-btn",
                                            onClick: insertLink,
                                            disabled: !linkUrl.value || linkUrl.value.trim() === ''
                                          }, " Apply ", 8, _hoisted_44)
                                        ])
                                      ])
                                    ], 4))
                                  : _createCommentVNode("", true)
                              ], 512),
                              _createElementVNode("button", {
                                type: "button",
                                class: "sms-composer__footer-icon-btn",
                                title: "Insert emoji",
                                onClick: _withModifiers(toggleEmojiPopover, ["stop"])
                              }, [
                                _createVNode(_unref(Icon), { icon: "mdi:emoticon-outline" })
                              ])
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              class: _normalizeClass(["sms-composer__send-btn", { 'sms-composer__send-btn--sending': _unref(isSending) }]),
                              onClick: handleSend,
                              disabled: !canSend.value || _unref(isUsageBlocked)
                            }, [
                              (_unref(isSending))
                                ? (_openBlock(), _createBlock(_unref(Icon), {
                                    key: 0,
                                    icon: "mdi:loading",
                                    class: "sms-composer__spin"
                                  }))
                                : (_openBlock(), _createBlock(_unref(Icon), {
                                    key: 1,
                                    icon: "mdi:send"
                                  })),
                              _cache[36] || (_cache[36] = _createTextVNode(" Send ", -1))
                            ], 10, _hoisted_45)), [
                              [_directive_tooltip, {
                    content: _unref(USAGE_BLOCKED_TOOLTIP),
                    disabled: !_unref(isUsageBlocked) || !canSend.value,
                  }]
                            ])
                          ], 512)
                        ])
                      ])
                    ])),
                _createVNode(StartSMSChatModal, {
                  show: showStartChatModal.value,
                  "org-phone-numbers": orgPhoneNumbers.value,
                  "contact-phone-numbers": contactPhoneNumbers.value,
                  "contact-id": __props.selectedBucket?.contact?.id || '',
                  "is-loading": _unref(isCreatingConversation),
                  "initial-message": initialModalMessage.value,
                  "icp-id": __props.icps?.find((i) => i.isDefault)?.id,
                  onClose: _cache[10] || (_cache[10] = ($event: any) => {
            showStartChatModal.value = false;
            initialModalMessage.value = '';
          }),
                  onCreateChat: handleCreateChat
                }, null, 8, ["show", "org-phone-numbers", "contact-phone-numbers", "contact-id", "is-loading", "initial-message", "icp-id"]),
                _createVNode(ActionConfirmationModal, {
                  show: showAiActionConfirm.value,
                  title: aiActionConfirmTitle.value,
                  message: aiActionConfirmMessage.value,
                  "confirm-text": "Generate",
                  "cancel-text": "Cancel",
                  "confirm-variant": "primary",
                  "dialog-max-width": "340px",
                  onConfirm: confirmAiAction,
                  onClose: cancelAiAction
                }, null, 8, ["show", "title", "message"])
              ]))
    ])
  ]))
}
}

})